import Header from './Components/Header/Header';
import Hero from './Components/Hero/Hero';
import About from './Components/About/About';
import Services from './Components/Services/Services';
import Schedule from './Components/Schedule/Schedule';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import './index.css';

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Services />
      <Schedule />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;